import ENDPOINT from 'constants/endPoint';
import axiosClient from 'utils/axios';

export default {
  async getRoomPriceTypes({ roomId, placeId }) {
    const path = ENDPOINT.ROOM_PRICE_TYPES(roomId, placeId);

    const response = await axiosClient.get(path);

    return response.data;
  },

  async updateRoomPriceTypes({ roomId, placeId, data }) {
    const path = ENDPOINT.UPDATE_ROOM_PRICE_TYPES(roomId, placeId);

    await axiosClient.put(path, data);
  },

  async getPlaceOtaData({ placeId }) {
    const path = ENDPOINT.PLACE_OTA_RATE_PLANS(placeId);

    const response = await axiosClient.get(path);

    return response.data;
  },
};
